<template>
  <el-dialog
    :visible.sync="dialog.visible"
    top="0"
    custom-class="orderDetails"
  >
    <span slot="title" class="d-flex align-items-center">
      <span class="tx-18 mg-r-15" style="color: #303133">{{
        $t("financial.订单详情")
      }}</span>
      <a
        href="javascript:;"
        class="tx-info"
        @click="isAccordionOrder = !isAccordionOrder"
        >{{
          isAccordionOrder ? $t("financial.折叠订单") : $t("financial.展开订单")
        }}</a
      >
    </span>
    <div class="modal-body pd-25">
      <!-- 表格 -->
      <div class="list-wrap">
        <!-- 列表 -->
        <div class="list-body d-flex mg-b-10">
          <div class="flex-1 pd-x-5 product-table bd-gray-400 pd-5">
            <!-- 订单信息 -->
            <div class="d-flex align-items-center">
              <div class="c-7 valign-middle tx-12 d-flex align-items-center">
                <div>
                  <a href="javascript:;" class="tx-info tx-underline tx-14">
                    <i
                      class="mg-x-5 fa tx-white tx-14"
                      :class="true ? 'fa-minus-square' : 'fa-plus-square'"
                    ></i>
                  </a>
                </div>
                <div class="flex-1">
                  <!-- 订单号 -->
                  <div class="d-flex align-items-center">
                    <span>{{ $t("financial.订单号") }}:&nbsp;</span>
                  </div>
                </div>
              </div>
              <div class="c-4">
                <!-- 发货时间 -->
                <div class="d-flex align-items-center">
                  <span>{{ $t("order.发货时间：") }}</span>
                </div>
              </div>
            </div>
            <!-- sku信息 -->
            <div class="mg-l-20 mg-r-20 order-pro">
              <!-- 列表 -->
              <div
                class="
                  valign-middle
                  tx-12
                  d-flex
                  align-items-center
                  mg-t-5 mg-b-5
                "
              >
                <div class="c-12 d-flex align-items-center purchase-img-wrap">
                  <!-- 图片 -->
                  <div class="pos-relative">
                    <a
                      href="javascript:;"
                      class="p-img-wrap pos-relative"
                      v-lazy:background-image=""
                    ></a>
                  </div>
                  <div style="width: calc(100% - 90px)">
                    <!-- 产品名称 -->
                    <p class="mg-b-5">
                      <span>{{ $t("financial.产品名称") }}:&nbsp;</span>
                      <span></span>
                    </p>
                    <!-- SKU -->
                    <p class="mg-b-5">
                      <span class="mg-r-5">SKU:&nbsp;</span>
                      <span class="tx-gray-300 mg-r-5">{{}}</span>
                      <a
                        href="javascript:;"
                        data-clipboard-text="testtesttestsku7"
                        class="to-clipboard tx-info mg-l-5"
                        ><i class="icon ion-clipboard"></i
                      ></a>
                    </p>
                    <!-- 属性 -->
                    <p class="mg-0">
                      <span>{{ $t("mall.属性：") }}</span>
                      <span></span>
                    </p>
                  </div>
                </div>
                <div class="c-6">
                  <!-- 数量 -->
                  <p class="mg-0">
                    <span>{{ $t("product.数量：") }}</span>
                    <span></span>
                  </p>
                </div>
                <div class="c-6">
                  <!-- 售价 -->
                  <p class="mg-b-5">
                    <span>{{ $t("product.售价：") }}</span>
                  </p>
                  <!-- 总价 -->
                  <p class="mg-0">
                    <span>{{ $t("financial.总价：") }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <api-loading :show="dialog.loading"></api-loading>
    <span slot="footer" class="dialog-footer">
      <button
        type="button"
        class="
          btn btn-primary
          tx-11 tx-uppercase
          pd-y-12 pd-x-25
          tx-mont tx-semibold
          mg-r-15
        "
        @click="save()"
      >
        {{ $t("financial.保存") }}
      </button>
      <button
        type="button"
        class="
          btn btn-secondary
          tx-11 tx-uppercase
          pd-y-12 pd-x-25
          tx-mont tx-semibold
        "
        @click="dialog.visible = false"
      >
        {{ $t("financial.取消") }}
      </button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      default() {
        return {
          visible: false,
          loading: false,
          item: {},
        };
      },
    },
  },
  data() {
    return {
      isAccordionOrder: false,
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
/deep/.orderDetails {
  top: 50%;
  transform: translateY(-50%);

  .el-dialog__header {
    padding: 20px 25px;
    border-bottom: 1px solid #e9ecef;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 15px;
    border-top: 1px solid #e9ecef;
  }
}

.list-heard {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.list-body {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.05);
}

.purchase-img-wrap .pos-relative {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}

.purchase-img-wrap .pos-relative .p-img-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  margin-right: 0;
  background-color: #fff;
  transform: scale(0.9, 0.9);
}
</style>